import React, { useMemo } from 'react';
import styled from 'styled-components';
import { AVATARS, dummyPicture } from './helper';
import Loading from 'components/Loading';
import { THEME } from './helper';
import { Row } from 'antd';
import { Col } from 'antd';
import { Button } from '@mui/material';

export default function CardDetail({ loading, handleRedirect, student }) {
  // Generate random indices for theme and avatar only once per student
  const randomThemeIndex = useMemo(() => {
    return Math.floor(Math.random() * THEME.length);
  }, [student?.student_id]); // Only recalculate if student changes

  const randomAvatarIndex = useMemo(() => {
    return Math.floor(Math.random() * AVATARS.length);
  }, [student?.student_id]); // Only recalculate if student changes

  return (
    <Col xs={24} sm={24} md={12} lg={8}>
      <div className="userSection">
        <CardItem className="userHeader" bgColor={THEME[randomThemeIndex]}>
          <div className="userHeadEdit"></div>
          <label>
            {student.firstName} {student.lastName}
          </label>
          <div className="userHeadPic">
            <img src={randomAvatarIndex ? AVATARS[randomAvatarIndex] : dummyPicture} />
          </div>
        </CardItem>
        <div className="noteSelf">
          <div style={{visibility: 'hidden'}} className="noteSelfInr">
            <div className="noteSelfLeft 222">
              <Button>Notes:</Button>
              <NoteText className="noteTxtAply"></NoteText>
            </div>
          </div>
          <div className="noteLinks">
            <ul>
              <li onClick={() => handleRedirect(student.student_id)}>
                <a>
                  {' '}
                  {loading ? (
                    <LoaderWrapper>
                      {' '}
                      <Loading size={25} />{' '}
                    </LoaderWrapper>
                  ) : null}{' '}
                  Student Profile
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Col>
  );
}

const LoaderWrapper = styled.div`
  position: absolute;
  z-index: 100;
`;

const CardItem = styled.div`
  background: ${(p) => (p.bgColor ? p.bgColor : THEME[0])};
`;
const NoteText = styled.span`
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
`;

